import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "info"
};
const _hoisted_2 = {
  class: "info_r"
};
const _hoisted_3 = {
  class: "info_r_r"
};
const _hoisted_4 = {
  class: "info_r_r_text"
};
const _hoisted_5 = {
  style: {
    "position": "absolute",
    "top": "-95px",
    "left": "-48px"
  }
};
const _hoisted_6 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_7 = {
  style: {
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_8 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_9 = {
  style: {
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_10 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_11 = {
  style: {
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_12 = {
  class: "info_r_l"
};
const _hoisted_13 = {
  style: {
    "width": "80%"
  }
};
const _hoisted_14 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "margin-top": "20px",
    "position": "relative"
  }
};
const _hoisted_15 = {
  key: 0,
  class: "gongzhonghaoCode code-box"
};
const _hoisted_16 = {
  key: 1,
  class: "weiboCode code-box"
};
const _hoisted_17 = {
  key: 2,
  class: "xhsCode code-box"
};
const _hoisted_18 = {
  key: 3,
  class: "douyinCode code-box"
};
const _hoisted_19 = {
  class: "aq"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_popup = _resolveComponent("popup");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(['zoom:' + ($setup.Client ? '20%' : '') + ';', {
      "margin-top": "30px"
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_popup, {
    show: $setup.loginShow,
    showState: $setup.showState,
    onModifyShowState: $setup.modifyShowState,
    onGetUserData: $setup.getUserData
  }, null, 8, ["show", "showState", "onModifyShowState", "onGetUserData"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_image, {
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group 254@2x.png"
  }), _createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, [_createVNode(_component_van_image, {
    style: {
      "width": "232px",
      "height": "60px"
    },
    src: "https://www.mimodental.com/assets/imgData/img/footer/contactUs.png"
  })]), _createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("h2", {
    style: {
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#FFFFFF"
    }
  }, " 米檬口腔（珠江新城店）", -1)), _createElementVNode("span", _hoisted_6, [_createVNode(_component_van_icon, {
    name: "location",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[8] || (_cache[8] = _createTextVNode("广州市天河区黄埔大道西高志大厦3楼", -1))]), _createElementVNode("span", _hoisted_7, [_createVNode(_component_van_icon, {
    name: "phone",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[9] || (_cache[9] = _createTextVNode("13326412720/020-83625907", -1))])]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("h2", {
    style: {
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#FFFFFF"
    }
  }, " 米檬口腔（黄埔旗舰店）", -1)), _createElementVNode("span", _hoisted_8, [_createVNode(_component_van_icon, {
    name: "location",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[11] || (_cache[11] = _createTextVNode("广州市黄埔区开创大道雪松中心103铺", -1))]), _createElementVNode("span", _hoisted_9, [_createVNode(_component_van_icon, {
    name: "phone",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[12] || (_cache[12] = _createTextVNode("020-32030994/18024089930", -1))])]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("h2", {
    style: {
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#FFFFFF"
    }
  }, " 米檬口腔（番禺青春店）", -1)), _createElementVNode("span", _hoisted_10, [_createVNode(_component_van_icon, {
    name: "location",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[14] || (_cache[14] = _createTextVNode("广州市番禺区钟村街文都二街6号(保利大都汇北侧)", -1))]), _createElementVNode("span", _hoisted_11, [_createVNode(_component_van_icon, {
    name: "phone",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[15] || (_cache[15] = _createTextVNode("020-36880989/19065227202", -1))])])])]), _createElementVNode("div", _hoisted_12, [_cache[22] || (_cache[22] = _createElementVNode("div", {
    style: {
      "margin": "30px 0",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/code2.png",
    alt: "",
    style: {
      "margin-bottom": "20px",
      "width": "150px",
      "height": "150px"
    }
  }), _createElementVNode("span", null, "扫一扫，找客服了解更多")], -1)), _createElementVNode("div", _hoisted_13, [_cache[21] || (_cache[21] = _createElementVNode("div", {
    style: {
      "background-color": "#fff",
      "color": "#13A4BF",
      "width": "200px",
      "text-align": "center",
      "padding": "5px 0",
      "border-radius": "100px"
    }
  }, " 还可以在这里找到我们", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    onMouseenter: _cache[0] || (_cache[0] = $event => $setup.showCode(0)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group35.png",
    alt: ""
  }, null, 32), _createElementVNode("img", {
    onMouseenter: _cache[2] || (_cache[2] = $event => $setup.showCode(1)),
    onMouseleave: _cache[3] || (_cache[3] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group36.png",
    alt: ""
  }, null, 32), _createElementVNode("img", {
    onMouseenter: _cache[4] || (_cache[4] = $event => $setup.showCode(2)),
    onMouseleave: _cache[5] || (_cache[5] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group37.png",
    alt: ""
  }, null, 32), _createElementVNode("img", {
    onMouseenter: _cache[6] || (_cache[6] = $event => $setup.showCode(3)),
    onMouseleave: _cache[7] || (_cache[7] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group38.png",
    alt: ""
  }, null, 32), $setup.codeShowState && $setup.codeShowIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[17] || (_cache[17] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/gongzhonghao.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : $setup.codeShowState && $setup.codeShowIndex == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[18] || (_cache[18] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/weiboCode.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : _createCommentVNode("", true), $setup.codeShowState && $setup.codeShowIndex == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[19] || (_cache[19] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/xhs.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : _createCommentVNode("", true), $setup.codeShowState && $setup.codeShowIndex == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[20] || (_cache[20] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/douyin.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : _createCommentVNode("", true)])])])])]), _createElementVNode("div", _hoisted_19, _toDisplayString($setup.textObj.name) + " " + _toDisplayString($setup.textObj.num) + " " + _toDisplayString($setup.textObj.code), 1)], 4);
}